import * as React from "react";
import FormPaper from "@components/atoms/FormPaper";
import SectionTitle from "@components/atoms/SectionTitle";
import FormikCheckbox from "@components/molecules/FormikCheckbox";
import LackFields from "@components/v201910/organisms/mgr/common/facility/items/LackFields";
import {
  WithStyles,
  withStyles,
  createStyles,
  StyleRules
} from "@material-ui/core/styles";

import { FormikProps } from "formik";
import { FacilityValues } from "@initialize/v201910/mgr/IAB/facility/initialValues";

const styles = (): StyleRules =>
  createStyles({
    comment: {
      fontSize: 12
    },
    helpIcon: {
      fontSize: 14.4,
      color: "#607d8b",
      verticalAlign: "sub"
    }
  });

type OwnProps = {
  formikProps: FormikProps<FacilityValues>;
};

type Props = OwnProps & WithStyles<typeof styles>;

const SubtractionItemFields = (props: Props): JSX.Element => (
  <FormPaper>
    <div style={{ marginBottom: 32 }}>
      <SectionTitle label="減算対象項目" />
    </div>
    <FormikCheckbox
      name="subtractionItem.establishedByLocalGovernmentsFlag"
      label="地方公共団体が設置"
    />
    <LackFields formikProps={props.formikProps} name="subtractionItem" />
  </FormPaper>
);

export default withStyles(styles)(SubtractionItemFields);
